var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGenericBankCard = function SvgGenericBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "generic-bank-card_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 26",
    style: {
      enableBackground: "new 0 0 40 26"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".generic-bank-card_svg__st0{fill:#8b9c8f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "generic-bank-card_svg__st0",
    d: "M0 0h40v6H0zM0 10h40v16H0z"
  })));
};
export default SvgGenericBankCard;